// Note: The first file of a module here, must also register the module

import "./document.component";
import "./view-document-modal.component";
